import type { ReactNode } from 'react';
import { createAppKit } from '@reown/appkit/react';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { base, mainnet, bsc, polygon, bscTestnet } from '@reown/appkit/networks';
import { WagmiProvider, createConfig, http } from 'wagmi';
import { mainnet as wagmiMainnet } from 'wagmi/chains';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../queryClient';

const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID;

const metadata = {
  name: 'Gila Quest',
  description: 'Gila Quest wallet bridge',
  url: typeof window !== 'undefined' ? window.location.origin : import.meta.env.VITE_DASHBOARD_BASE_URL,
  icons: ['https://gilaquest.infinica.xyz/assets/logo-Dqb8_ew0.png'],
};

const networks: [typeof base, typeof mainnet, typeof bsc, typeof polygon, typeof bscTestnet] = [
  base,
  mainnet,
  bsc,
  polygon,
  bscTestnet,
];

let wagmiAdapter: WagmiAdapter | null = null;

const fallbackConfig = createConfig({
  chains: [wagmiMainnet],
  transports: {
    [wagmiMainnet.id]: http(),
  },
  multiInjectedProviderDiscovery: false,
});

if (!projectId) {
  throw new Error('VITE_WALLETCONNECT_PROJECT_ID is not set. AppKit modal cannot initialize.');
}

wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: true,
});

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: false,
    send: false,
    email: false,
    emailShowWallets: false,
    reownAuthentication: false,
    socials: false,
  },
});

export function AppKitProvider({ children }: { children: ReactNode }) {
  const wagmiConfig = wagmiAdapter?.wagmiConfig ?? fallbackConfig;

  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
